import { forwardRef, useEffect, useMemo, useState } from 'react'
import { AimOutlined } from '@ant-design/icons'
import { Draggable } from '@hello-pangea/dnd'
import { GalleryImage } from '../../Slices/PIM/ImagesSlices'
import DraggableImage from './DraggableImage'
import { retrieveImageUrl } from '../../Helpers/GalleryHelper'
import { useAppSelector } from '../../hooks'

function PimGallery(props, ref) {
  const images = useAppSelector(state => state.present.images.images)

  const [height, setHeight] = useState(0)

  const element = document.getElementById(`box-${props.gallery.id}`)

  useEffect(() => {
    if (element) {
      setHeight(element?.clientHeight)
    }
  }, [element, height])

  const droppableContainerStyle = useMemo(() => {
    return height !== 0 ? { maxHeight: height + 11 } : {}
  }, [height])

  return (
    <div
      key={`${props.gallery.id}`}
      id={`${props.gallery.id}`}
      className={'gallery-box d-block position-relative' + (props.droppableSnapshot.isDraggingOver ? ' active' : '')}
    >
      <div
        className='gallery-image-list d-flex justify-end flex-wrap'
        ref={ref}
        {...props.droppableProvided.droppableProps}
        id={`box-${props.gallery.id}`}
        style={droppableContainerStyle}
      >
        {props.imageList.map((galleryImage: GalleryImage, index: number) => {
          return (
            <Draggable
              key={`gallery-${props.gallery.id}-img-${galleryImage.id}`}
              draggableId={`gallery-${props.gallery.id}-img-${galleryImage.id}`}
              index={index}
            >
              {(draggableProvided, draggableSnapshot) => (
                <DraggableImage
                  containerClassName={'drag-wrapper cursor-grab pa-2'}
                  draggableProps={draggableProvided.draggableProps}
                  dragHandleProps={draggableProvided.dragHandleProps}
                  ref={draggableProvided.innerRef}
                  imageId={`img-${galleryImage.id}-gallery-${props.gallery.id}`}
                  imageUrl={retrieveImageUrl(images, galleryImage.id)}
                  className={'responsive-img image-preview'}
                  enableMenu={false}
                />
              )}
            </Draggable>
          )
        })}
        {props.droppableProvided.placeholder}
      </div>

      <div className='d-flex justify-space-between pa-1'>
        <div className='d-inline-flex'>
          <AimOutlined />
        </div>
        <div className='d-inline-flex'>{props.gallery.name}</div>
      </div>
    </div>
  )
}

export default forwardRef(PimGallery)
